import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/layout/Sidebar';
import Topbar from '../components/layout/Topbar';

const HIDDEN_KEY = 'sidebarHidden';
const DESKTOP_QUERY = '(min-width: 1024px)'; // Tailwind `lg`

function readHidden() {
  try {
    return localStorage.getItem(HIDDEN_KEY) === 'true';
  } catch {
    return false;
  }
}

export default function AdminLayout() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  // Desktop only: the ☰ button hides the sidebar so the page uses the full width
  const [sidebarHidden, setSidebarHidden] = useState(readHidden);

  const handleMenuClick = () => {
    if (!window.matchMedia(DESKTOP_QUERY).matches) {
      setMobileNavOpen(true);
      return;
    }
    setSidebarHidden((hidden) => {
      try {
        localStorage.setItem(HIDDEN_KEY, String(!hidden));
      } catch {
        // storage unavailable; the toggle still works for this session
      }
      return !hidden;
    });
  };

  return (
    <div className="min-h-screen bg-background text-on-surface">
      <Sidebar mobileOpen={mobileNavOpen} desktopHidden={sidebarHidden} onClose={() => setMobileNavOpen(false)} />
      <div
        className={`flex flex-col min-w-0 transition-[padding] duration-200 ${sidebarHidden ? '' : 'lg:pl-16 xl:pl-[260px]'}`}
      >
        <Topbar onMenuClick={handleMenuClick} sidebarHidden={sidebarHidden} />
        <main className="w-full pt-20 px-4 sm:px-8 pb-12">
          <div className="max-w-[1400px] mx-auto flex flex-col gap-6">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
